module.exports = __webpack_public_path__ + "SourceSans3-Bold.otf.d29ca.woff";